export default "__VITE_ASSET__D7o9TmM3__"